module.exports = __webpack_public_path__ + "static/media/feedback-banner.0dcfe1f4.png";